import React from 'react'
import { View } from 'styles/reactnative'

import { Select } from 'antd'
import { column_price } from '../../../components/AdminUserModal/UserInfoTabs/column_price'
import TableAPI from '../../../components/TableAPI'
import { useExchangeList } from '../../../hooks/trade/exchangeList'

const CoinPrice = ({ title, type }: any) => {
	const { data: EPS } = useExchangeList()
	const [ep_id, setEp_id] = React.useState<any>('*')
	return (
		<View style={{ width: '100%' }}>
			<Select
				value={ep_id}
				onChange={e => {
					setEp_id(e)
				}}
				filterOption={true}
				options={[
					{ value: '*', label: '전체종목' },
					...EPS?.map((item: any) => {
						return {
							value: item.id,
							label: item.name + ' (' + item?.pairs + ')',
						}
					}),
				]}
				style={{ marginRight: 10, minWidth: 200 }}
			/>

			<TableAPI
				title={'종목별시세'}
				columns={column_price}
				usermodal={false}
				datesearch={true}
				height={false}
				apikey={`/trade/pricelist?ep_id=${ep_id}&t=`}
			/>
		</View>
	)
}

export default React.memo(CoinPrice)
